import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import axios from "axios";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import "../styles/onlinetestpage.css";
import TestInstructions from "../components/TestInstructions";
import TestConsole from "../components/TestConsole";
import GeneralInstructions from "../components/GeneralInstructions";
import { useTimer } from "react-timer-hook";
import Navbar from "../components/Navbar";

const OnlineTestPage = () => {
  const [state, setState] = useState("gen"); // 'gen' | 'test-ins' | 'console'
  const [quesData, setQuesData] = useState([]); // array of questions
  const [timeExpired, setTimeExpired] = useState(0);
  const [rankArray, setRankArray] = useState([]);
  const filteredScoreArray = [];

  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, []);

  const id = (params.id || "").replaceAll("-", " ");

  let type = ""
  let quesNumber = 100;
  if (location.state && location.state.type) {
    type = location.state.type;
    quesNumber = location.state.quesNumber;
  }

  // login check (unchanged)
  const itemStr = localStorage.getItem("isLogin");
  let item = null;
  try {
    item = itemStr ? JSON.parse(itemStr) : null;
  } catch (e) {
    item = null;
  }
  const now = new Date();
  if (!itemStr || (item && item.expiry < now.getTime())) {
    // user not logged in or expired
    navigate("/login");
  }

  // generate an id for this test session (kept original behaviour)
  const testId = Math.random().toString(36).slice(2);

  // Timer component (keeps original useTimer usage)
  function MyTimer({ expiryTimestamp }) {
    const {
      seconds,
      minutes,
      hours,
      isRunning,
      start,
      pause,
      resume,
      restart,
    } = useTimer({ expiryTimestamp, onExpire: () => void finishTest() });

    return (
      <div className="ot-timer" aria-live="polite">
        <span className="ot-time">{String(hours).padStart(2, "0")}</span>
        <span className="ot-colon">:</span>
        <span className="ot-time">{String(minutes).padStart(2, "0")}</span>
        <span className="ot-colon">:</span>
        <span className="ot-time">{String(seconds).padStart(2, "0")}</span>
      </div>
    );
  }

  // finish test handler
  const finishTest = function () {
    setTimeExpired(1);
  };

  // API calls - kept unchanged logic
  const catArr = [id];

  const getQuestions = async () => {
    try {
      const json = JSON.stringify({
        catArray: catArr,
        questions: quesNumber
        
      });
      const headers = {
        "Content-Type": "application/json",
      };

      await axios
        .post(
          "https://epolylearning.com/Services/polyquiz.svc/GetCatwiseTestQues",
          json,
          { headers }
        )
        .then((response) => {
          const testQues = response.data.GetCatwiseTestQuesResult;
          // ensure array fallback
          setQuesData(Array.isArray(testQues) ? testQues : []);
        });
    } catch (error) {
      console.error("GetQuestions error:", error?.response || error?.message || error);
    }
  };

  const getSubcatQuestions = async () => {
    try {
      const json = JSON.stringify({
        catArray: catArr,
      });
      const headers = {
        "Content-Type": "application/json",
      };
      await axios
        .post(
          "https://epolylearning.com/Services/polyquiz.svc/GetSubCatwiseTestQues",
          json,
          { headers }
        )
        .then((response) => {
          const testQues = response.data.GetSubCatwiseTestQuesResult;
          setQuesData(Array.isArray(testQues) ? testQues : []);
        });
    } catch (error) {
      console.error("GetSubcatQuestions error:", error?.response || error?.message || error);
    }
  };

  const getRankData = () => {
    try {
      const json = JSON.stringify({ testCat: location.state.type, testName: id });
      console.log(json);
      const headers = {
        "Content-Type": "application/json",
      };
      axios
        .post("https://epolylearning.com/Services/polyquiz.svc/GetRankData", json, {
          headers,
        })
        .then((response) => {
          const RankData = response.data;
          const arr = [];
          for (let i = 0; i < (RankData?.GetRankDataResult || []).length; i++) {
            arr.push(RankData.GetRankDataResult[i].Score);
            console.log(arr);
          }
          setRankArray(arr);
        });
    } catch (error) {
      console.error("GetRankData error:", error);
    }
  };

  // fetch on mount
  useEffect(() => {
    if (type === "category-test") {
      getQuestions();
    } else if (type === "subcategory-test") {
      getSubcatQuestions();
    } else {
      // default: try catwise
      getQuestions();
    }
    getRankData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // compute expiry timestamp for timer: quesData.length minutes
  const time = new Date();
  // default to 30 minutes if quesData length missing
  const durationMinutes = quesData && quesData.length ? quesData.length : 30;
  time.setSeconds(time.getSeconds() + durationMinutes * 60);

  return (
    <>
      <MetaTags>
        <title>{id} Online Quiz - PolyQuizz</title>
        <meta id="meta-description" name="description" />
      </MetaTags>

      <main className="ot-page-root">
       <section className="ot-header">
  <div className="ot-header-inner">
    <div className="ot-left ot-left-centered">
      <h2 className="ot-title">{id.toUpperCase()} — Full Practice Test</h2>
      <p className="ot-subtitle">Timed, exam-style practice with instant feedback and analytics.</p>
    </div>

    <div className="ot-center">
      {/* header center can remain empty or contain breadcrumbs */}
    </div>

    <div className="ot-right">
      {state === "console" && (
        <>
          <div className="ot-meta">
            <div className="ot-meta-item">
              <div className="ot-meta-label">Max Marks</div>
              <div className="ot-meta-value">{quesData.length || 0}</div>
            </div>

            <div className="ot-meta-item">
              <div className="ot-meta-label">Time Left</div>
              <div className="ot-meta-value">
                <MyTimer expiryTimestamp={time} />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  </div>
</section>

        <section className="ot-content">
          {state === "gen" && (
  <div className={`ot-block ot-block-gen ${state === 'gen' ? 'active' : ''}`}>
    <GeneralInstructions
      quesLength={quesData.length || 0}
      onProceed={() => setState("test-ins")}
      proceedLabel="Next"
    />
  </div>
)}

          {/* Test Instructions */}
          {state === "test-ins" && (
  <div className={`ot-block ot-block-ins ${state === 'test-ins' ? 'active' : ''}`}>
    <TestInstructions
      catName={id}
      quesLength={quesData.length || 0}
      onBegin={() => setState("console")}
    />
  </div>
)}

          {/* Test Console */}
          {state === "console" && (
  <div className={`ot-block ot-block-console ${state === 'console' ? 'active' : ''}`}>
    <TestConsole
      quesData={quesData}
      catName={id}
      type={type}
      testId={testId}
      MyTimer={MyTimer}
      time={time}
      timeExpired={timeExpired}
      rankArray={rankArray}
    />
  </div>
)}
        </section>
      </main>
    </>
  );
};

export default OnlineTestPage;
